import AddTagControl from "../AddTagControl";
import React from "react";

type TagMenuType = {
    dataKey: any;
    reRenderTrigger?: any;
    updateCallback: any;
}

const TagMenu = (props: TagMenuType) => {
    const HandleCallback = (tag: any, checked: boolean) => {
        props.updateCallback(tag, checked);
    }

    return (
        <AddTagControl
            listAlwaysVisible={true}
            listInMenu={true}
            name={'tagMenu'}
            menuToggled={props.reRenderTrigger}
            dataKey={props.dataKey}
            updateCallback={(e:any, b: boolean) => HandleCallback(e, b)}
        />
    )
}

const TagMenuContext = (props: TagMenuType) => {
    return (
        <TagMenu {...props} />
    )
}

export {TagMenu, TagMenuContext}
